let html = `<div class="modal-loading">
    
</div>`

export default html